import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, FormError } from "@/components/auth/AuthShell";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { reload } = useAuth();
  const [state, setState] = useState({ loading: true, error: "" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => { setState({ loading: false, error: "" }); reload(); })
      .catch((err) => setState({ loading: false, error: errorMessage(err) }));
  }, [params, reload]);

  return (
    <AuthShell title="Confirmação de e-mail" testid="verify-page">
      {state.loading ? <Loader2 className="h-6 w-6 animate-spin text-slate-400" data-testid="verify-loading" /> : (
        <div className="space-y-4">
          {state.error ? <FormError error={state.error} /> : (
            <p className="flex gap-2 text-sm text-emerald-200" data-testid="verify-done"><CheckCircle2 className="h-5 w-5 shrink-0" /> E-mail confirmado. Obrigado!</p>
          )}
          <Button asChild className="h-11 w-full rounded-full font-semibold"><Link to="/" data-testid="verify-go-app">Ir para o Ciclo Certo</Link></Button>
        </div>
      )}
    </AuthShell>
  );
}
